import { STRING } from 'resources'

import {
  SectionTitle,
  TitleExample,
  RegularExample,
  ItalicExample,
  BoldExample,
  BoldItalicExample,
  ExtraBoldExample,
  ExtraBoldItalicExample,
  MediumExample,
  MediumItalicExample,
  SemiBoldExample,
  SemiBoldItalicExample,
} from './styles'

const TypographySection = () => (
  <>
    <SectionTitle>{STRING.designSystemScreen.typography}</SectionTitle>
    <TitleExample>{STRING.designSystemScreen.titleBold}</TitleExample>
    <RegularExample>{STRING.designSystemScreen.regularText}</RegularExample>
    <ItalicExample>{STRING.designSystemScreen.italicText}</ItalicExample>
    <BoldExample>{STRING.designSystemScreen.boldText}</BoldExample>
    <BoldItalicExample>{STRING.designSystemScreen.boldItalicText}</BoldItalicExample>
    <ExtraBoldExample>{STRING.designSystemScreen.extraBold}</ExtraBoldExample>
    <ExtraBoldItalicExample>{STRING.designSystemScreen.extraBoldItalic}</ExtraBoldItalicExample>
    <MediumExample>{STRING.designSystemScreen.mediumText}</MediumExample>
    <MediumItalicExample>{STRING.designSystemScreen.mediumItalic}</MediumItalicExample>
    <SemiBoldExample>{STRING.designSystemScreen.semiBold}</SemiBoldExample>
    <SemiBoldItalicExample>{STRING.designSystemScreen.semiBoldItalic}</SemiBoldItalicExample>
  </>
)

export default TypographySection
